// Styles
import { getOmnibusPriceFromAPI, hideOmnibuspriceContainer } from '../../scripts/vendor/omnibus';
import './product-template.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTemplate = async (context) => {
  const productTemplateSection = context.closest('.shopify-section');
  if (!productTemplateSection) return;

  const templateContainer = productTemplateSection.querySelector('.product-template__container');
  const omnibusContainers = productTemplateSection.querySelectorAll('.omnibusprice');
  if (templateContainer && omnibusContainers.length > 0) {
    const brand = omnibusContainers[0].dataset.omnibus_brand;
    if (brand) {
      const renderOmnibusPrices = price => {
        omnibusContainers.forEach(omnibusContainer => {
          const productCompareAtPrice = parseInt(omnibusContainer.dataset.compare_at_price) / 100;
          if (!productCompareAtPrice) {
            hideOmnibuspriceContainer(omnibusContainer);
          } else {
            const omnibusValue = omnibusContainer.querySelector('.omnibusprice-value');

            omnibusValue.innerText = window.theme.Currency.formatMoney(price * 100, window.theme.moneyFormat);
            omnibusContainer.classList.remove('hidden');
          }
        });
      }

      var variantID = omnibusContainers[0].dataset.omnibus_id;
      renderOmnibusPrices(await getOmnibusPriceFromAPI(brand, variantID));
      $(templateContainer).on('variantPriceChange', async function (variant) {
        omnibusContainers.forEach(omnibusContainer => {
          omnibusContainer.dataset.variant_price = variant.variant.price;
          omnibusContainer.dataset.compare_at_price = variant.variant.price;
          omnibusContainer.dataset.omnibus_id = variant.variant.id;
        });

        var variantID = omnibusContainers[0].dataset.omnibus_id;
        renderOmnibusPrices(await getOmnibusPriceFromAPI(brand, variantID));
      });
    }
  }

  const frequentQuestionsContainer = productTemplateSection.querySelector('.product__frequent-questions');
  if (frequentQuestionsContainer) {
    const swiperContainer = frequentQuestionsContainer.querySelector('.product-frequent-questions__answers-container');
    var swiper;
    if (swiperContainer) {
      swiper = new Swiper(swiperContainer, {
        loop: false,
        slidesPerView: 1,
        autoHeight: true,
        pagination: {
          el: frequentQuestionsContainer.querySelector('.product-frequent-questions__pagination'),
          clickable: true
        },
        navigation: {
          prevEl: frequentQuestionsContainer.querySelector('.product-frequent-questions__arrow.product-frequent-questions__arrow--left'),
          nextEl: frequentQuestionsContainer.querySelector('.product-frequent-questions__arrow.product-frequent-questions__arrow--right')
        },
        breakpoints: {
          751: {
            autoHeight: true
          }
        }
      });
    }

    const titleContainer = frequentQuestionsContainer.querySelector('.product-frequent-questions__title');
    if (titleContainer) {
      const swiperWrapper = frequentQuestionsContainer.querySelector('.swiper-wrapper');
      titleContainer.addEventListener('click', () => {
        if (window.innerWidth > 750) return;
        if (titleContainer.classList.contains('open')) {
          titleContainer.classList.remove('open');
          swiperWrapper.animate(
            {
              height: [`${swiperWrapper.clientHeight}px`, '0px']
            },
            {
              duration: 300
            }
          );
        } else {
          titleContainer.classList.add('open');
          if (swiper) {
            swiper.slideTo(swiper.activeIndex);
          }
        }
      });
    }
  }
  const talkingLabelOverlay = productTemplateSection.querySelectorAll('.product-single, .breadcrumbs.breadcrumbs--mobile');
  const talkingLabelContentWrapper = productTemplateSection.querySelector('.talking-label-data__wrapper');

  const splitAndRotate = (el) => {
    if (typeof (el.dataset) === 'undefined' || typeof (el.dataset.title) === 'undefined') return;
    el.dataset.title.split('').forEach((letter, index) => {
      const letterElement = document.createElement('span');
      letterElement.innerText = letter;
      letterElement.style.transform = `rotate(${index * 7}deg)`;
      el.appendChild(letterElement);
    });
    el.classList.add('show');
  };

  const levelOpener = (level) => {
    const levelWrapper = talkingLabelContentWrapper.querySelector(`.talking-label-data__level[data-level="${level}"]:not(:empty)`);
    if (levelWrapper) {
      talkingLabelOverlay.forEach(overlayEl => {
        overlayEl.style.display = 'none';
      });

      talkingLabelContentWrapper.classList.add('open');
      talkingLabelContentWrapper.setAttribute('data-open-level', level);
      levelWrapper.classList.add('open');

      talkingLabelContentWrapper.querySelectorAll(`.talking-label-data__level.open:not([data-level="${level}"])`).forEach(openLevel => {
        openLevel.classList.remove('open');

        if (openLevel.classList.contains('talking-label-data__level--third')) {
          const accordionContentWrapper = openLevel.querySelector('.talking-label-data-level__accordion-content');
          if (accordionContentWrapper) {
            accordionContentWrapper.style.maxHeight = '';
          }
        }
      });

      if (level.split('/').length <= 1) {
        talkingLabelContentWrapper.querySelectorAll(`.talking-label-data-heading__icon-wrapper.active:not([data-icon-level="${level}"])`).forEach(active => {
          active.classList.remove('active');
        });
      } else if (level.split('/').length <= 2) {
        talkingLabelContentWrapper.querySelectorAll(`.talking-label-data-heading__second-level-icons .talking-label-data-heading__icon-wrapper.active:not([data-icon-level="${level}"])`).forEach(active => {
          active.classList.remove('active');
        });
      }

      const selectedIcon = talkingLabelContentWrapper.querySelector(`.talking-label-data-heading__icon-wrapper[data-icon-level="${level}"]`);
      if (selectedIcon) {
        selectedIcon.classList.add('active');
      }

      const selectedTitle = talkingLabelContentWrapper.querySelector(`.talking-label-data-heading__title[data-level-title="${level}"]`);
      if (selectedTitle) {
        talkingLabelContentWrapper.querySelectorAll(`.talking-label-data-heading__title.active:not([data-level-title="${level}"])`).forEach(activeTitle => {
          activeTitle.classList.remove('active');
        });
        selectedTitle.classList.add('active');
      }

      if (levelWrapper.classList.contains('talking-label-data__level--third')) {
        const accordionContentWrapper = levelWrapper.querySelector('.talking-label-data-level__accordion-content');
        const accordionContentInner = levelWrapper.querySelector('.talking-label-data-level__accordion-content--inner');
        if (accordionContentWrapper && accordionContentInner) {
          const paddingTop = parseInt(getComputedStyle(accordionContentWrapper).paddingTop.replace('px', ''));
          const paddingBottom = parseInt(getComputedStyle(accordionContentWrapper).paddingBottom.replace('px', ''));

          if ((accordionContentInner.scrollHeight + paddingTop + paddingBottom) < accordionContentWrapper.clientHeight) {
            accordionContentWrapper.style.maxHeight = `${accordionContentInner.clientHeight + paddingTop + paddingBottom + 32}px`;
          }
        }
      }

      window.scrollTo(0, 0);
    }
  };

  const closeLevels = () => {
    talkingLabelContentWrapper.querySelectorAll('.talking-label-data__level.open').forEach(openLevel => {
      openLevel.classList.remove('open');

      if (openLevel.classList.contains('talking-label-data__level--third')) {
        const accordionContentWrapper = openLevel.querySelector('.talking-label-data-level__accordion-content');
        if (accordionContentWrapper) {
          accordionContentWrapper.style.maxHeight = '';
        }
      }
    });
    talkingLabelContentWrapper.classList.remove('open');
    talkingLabelContentWrapper.querySelectorAll('.talking-label-data-heading__icon-wrapper.active').forEach(activeIcon => {
      activeIcon.classList.remove('active');
    });
    talkingLabelContentWrapper.removeAttribute('data-open-level');
    talkingLabelOverlay.forEach(overlayEl => {
      overlayEl.style.display = '';
    });
  };

  if (talkingLabelContentWrapper) {
    talkingLabelContentWrapper.querySelectorAll('.talking-label-data-heading__icon-title[data-title], .talking-label-data-level__icon-title[data-title]').forEach(titleContainer => {
      splitAndRotate(titleContainer);
    });

    const closeIcon = talkingLabelContentWrapper.querySelector('.talking-label-data-heading__close');
    if (closeIcon) {
      closeIcon.addEventListener('click', () => {
        closeLevels();
      });
    }

    const talkingLabelIconsWrapper = productTemplateSection.querySelector('.talking-label-icons__wrapper');
    if (talkingLabelIconsWrapper) {
      talkingLabelIconsWrapper.querySelectorAll('.talking-label-icons-icon__title[data-title]').forEach(titleContainer => {
        splitAndRotate(titleContainer);
      });

      talkingLabelIconsWrapper.querySelectorAll('.talking-label-icons-icon__media[data-level]').forEach(icon => {
        const level = icon.dataset.level;
        if (level) {
          icon.addEventListener('click', () => {
            levelOpener(level);
          });
        }
      });

      talkingLabelContentWrapper.querySelectorAll('.talking-label-data-level__icon-wrapper[data-level], .talking-label-data__level--second .talking-label-data-level__icon-wrapper[data-level], .talking-label-data-level__accordion[data-level]').forEach(icon => {
        const level = icon.dataset.level;
        if (level) {
          icon.addEventListener('click', () => {
            levelOpener(level);
          });
        }
      });

      talkingLabelContentWrapper.querySelectorAll('.talking-label-data-heading__icon-wrapper[data-icon-level]').forEach(icon => {
        const level = icon.dataset.iconLevel;
        if (level) {
          icon.addEventListener('click', () => {
            levelOpener(level);
          });
        }
      });

      const goBackButton = talkingLabelContentWrapper.querySelector('.talking-label-data-heading__go-back');
      if (goBackButton) {
        goBackButton.addEventListener('click', () => {
          const activeIcon = goBackButton.parentElement.querySelector('.talking-label-data-heading__icon-wrapper.active');
          if (activeIcon) {
            activeIcon.click();
          }
        });
      }
    }
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-template__container'), (el) => {
    window.dAgency.initProductTemplate(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-template__container'), (el) => {
      window.dAgency.initProductTemplate(el);
    });
  });
}
